import TableChannels from './TableChannels'

export default TableChannels



// WEBPACK FOOTER //
// ./src/views/Channels/components/TableChannels/index.js